export const strongboxPrimary = '#01bbc8';
export const strongboxSecondary = '#01bbc8';

export const sbxCheckboxPrimary = '#ff7348';
export const sbxCheckboxSecondary = '#ff7348';

export const jsonHeaders = {
    'Accept': 'application/json',
    'Content-Type': 'application/json',
};

export const fgConnectName = 'Finagraph Connect';
export const fgConnectDownloadUrl = 'https://sbxnexusstgncus.blob.core.windows.net/setup/v2/qbd/default/FinagraphConnect.msi';

export const termsOfUseUrl = 'https://sbxfdppublicstgncus.blob.core.windows.net/docs/Strongbox.TermsOfService.pdf';

export const headerConstants = {
    /**
     * Header key for the user's timezone offset. Corresponds to a value in
     * RequestConstants.cs.
     */
    timezoneOffsetHeaderKey: 'Timezone-Offset',
};
